import React from 'react';
import { Container } from '../components/ui/Container';
export function TermsPage() {
  return <div className="bg-white py-20 lg:py-28" data-id="element-510">
      <Container size="md" data-id="element-511">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-8" data-id="element-512">
          Terms of Service
        </h1>
        <p className="text-gray-500 mb-12" data-id="element-513">Last updated: January 1, 2025</p>

        <div className="prose prose-lg prose-indigo max-w-none" data-id="element-514">
          <h2 data-id="element-515">1. Acceptance of Terms</h2>
          <p data-id="element-516">
            By accessing and using Flowsense ("Service"), operated by Acciom
            Limited, you accept and agree to be bound by the terms and provision
            of this agreement. In addition, when using these particular
            services, you shall be subject to any posted guidelines or rules
            applicable to such services.
          </p>

          <h2 data-id="element-517">2. Description of Service</h2>
          <p data-id="element-518">
            Flowsense provides an AI-powered platform for optimizing email
            marketing flows ("Service"). You understand and agree that the
            Service is provided "AS-IS" and that Flowsense assumes no
            responsibility for the timeliness, deletion, mis-delivery or failure
            to store any user communications or personalization settings.
          </p>

          <h2 data-id="element-519">3. User Account</h2>
          <p data-id="element-520">
            To access certain features of the Service, you may be required to
            register for an account. You agree to provide accurate, current, and
            complete information during the registration process and to update
            such information to keep it accurate, current, and complete.
          </p>

          <h2 data-id="element-521">4. Payment Terms</h2>
          <p data-id="element-522">
            The Service offers both free and paid plans. If you choose a paid
            plan, you agree to pay all fees or charges to your account in
            accordance with the fees, charges, and billing terms in effect at
            the time a fee or charge is due and payable.
          </p>

          <h2 data-id="element-523">5. Intellectual Property</h2>
          <p data-id="element-524">
            The Service and its original content, features, and functionality
            are and will remain the exclusive property of Flowsense and its
            licensors. The Service is protected by copyright, trademark, and
            other laws.
          </p>

          <h2 data-id="element-525">6. Termination</h2>
          <p data-id="element-526">
            We may terminate or suspend your account immediately, without prior
            notice or liability, for any reason whatsoever, including without
            limitation if you breach the Terms. Upon termination, your right to
            use the Service will immediately cease.
          </p>

          <h2 data-id="element-527">7. Limitation of Liability</h2>
          <p data-id="element-528">
            In no event shall Flowsense, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the Service.
          </p>

          <h2 data-id="element-529">8. Governing Law</h2>
          <p data-id="element-530">
            These Terms shall be governed and construed in accordance with the
            laws of the United Kingdom, without regard to its conflict of law
            provisions.
          </p>

          <h2 data-id="element-531">9. Changes</h2>
          <p data-id="element-532">
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will try to
            provide at least 30 days notice prior to any new terms taking
            effect.
          </p>

          <h2 data-id="element-533">10. Contact Us</h2>
          <p data-id="element-534">
            If you have any questions about these Terms, please contact us at:
          </p>
          <p data-id="element-535">
            Flowsense by Acciom Limited
            <br data-id="element-536" />
            Email: info@acciom.co.uk
          </p>
        </div>
      </Container>
    </div>;
}